import React, { useState, useRef } from 'react';
import text from './text';

const language = window.location.hash === '#en' ? 'eng' : 'hun';


const VEHICLE_TYPES = [
  text[language].vehicleToolTip[0],
  text[language].vehicleToolTip[1],
  text[language].vehicleToolTip[2],
  text[language].vehicleToolTip[3],
  text[language].vehicleToolTip[4],
  text[language].vehicleToolTip[5],
  text[language].vehicleToolTip[6],
  text[language].vehicleToolTip[7],
];

export default ({hoverData, deckGL, filterFn}) => {
  const getSeverityText = (v) => {
    switch (v) {
      case 2:
        return text[language].severity[v]
      case 4:
        return text[language].severity[v]
      case 8:
          return text[language].severity[v]
      default:
          return ''
    }
  }

  const thereIsMore = (more) => {
    if(more) {
      return (
        <tr><td>...</td></tr>
      ); 
    }
  }
  
  const renderDetails = (d) => {
    let isMore = false;
    if(d.length > 10) {
      d.length = 10;
      isMore = true;
    }
    return (
      <div>
        <table>
          <tbody>
          <tr>
              <th>{text[language].toolTip[0]}</th>
              {/* <th>{text[language].toolTip[1]}</th> */}
              <th>{text[language].toolTip[3]}</th>
              <th>{text[language].toolTip[4]}</th>
          </tr>
          {
            d.map((k, key) =>
            <tr key={key}>
              <td>{k.properties.date.replace('-','.')}.</td>
              {/* <td>{k.properties.road ? k.properties.road : '-'}</td> */}
              <td>{getSeverityText(k.properties.severity30)}</td>
              <td>{VEHICLE_TYPES[(k.properties.vehicle)-1]}</td>
            </tr>
            )
          }
           {thereIsMore(isMore)}
          </tbody>
        </table>
      </div>
    );
  }

  if(hoverData.obj == null) return ('')
  if(hoverData.type === 'hexagon') {
    return (
      <div className="tool-tip" style={{left: hoverData.x, top: hoverData.y}}>
        {hoverData.obj.elevationValue + " " + text[language].accident}
      </div>
    );
  }
  if(hoverData.type === 'scatterplot') {
    let multyData = deckGL.current.pickMultipleObjects({
      x: hoverData.x,
      y: hoverData.y,
      radius: 1,
      layerID: 'scatterplot',
      depth: 50
    });

    //filter only visiable points
    multyData = multyData.map((d) => {return (filterFn(d.object) ? d.object : null )});
    multyData = multyData.filter((d) => {return d != null});
    multyData.sort(function(a, b) {
      return new Date(b.properties.date) - new Date(a.properties.date);
    });

    if (multyData.length > 0 ) {
      return (
        <div className="tool-tip" style={{left: hoverData.x, top: hoverData.y}}>
          {multyData.length + " " + text[language].accident}
          {renderDetails(multyData)}
        </div>
      );
    }
  }
  return ('');
}
